import { Component, Input } from '@angular/core';
import { Channel, ChannelFns } from 'ops/common/models/channel';
import Decimal from 'decimal.js';

@Component({
    selector: 'app-alarm-range-list',
    templateUrl: './alarm-range-list.component.html',
    styleUrls: ['./alarm-range-list.component.scss'],
    standalone: false
})
export class AlarmRangeListComponent {
    @Input() channel: Channel;

    transform(value: number) {
        const transformed = ChannelFns.transformValue(this.channel, value);
        if(!transformed) return;
        return typeof transformed === 'number'
            ? new Decimal(value).div(this.channel.fcuData.scale).toString()
            : transformed;
    }

    isDigital = () => ChannelFns.isDigital(this.channel);

    getUnits = () => this.channel.opsData.measurementUnit;

    getNormalMin = () => this.transform(this.channel.fcuData.normalRange.min);
    getNormalMax = () => this.transform(this.channel.fcuData.normalRange.max);
    isVeryLowAlarmEnabled = () => this.channel.fcuData.alarmSettingVeryLow.enable;
    getVeryLowThreshold = () => this.transform(this.channel.fcuData.alarmSettingVeryLow.setPoint);
    isLowAlarmEnabled = () => this.channel.fcuData.alarmSettingLow.enable;
    getLowThreshold = () => this.transform(this.channel.fcuData.alarmSettingLow.setPoint);
    isHighAlarmEnabled = () => this.channel.fcuData.alarmSettingHigh.enable;
    getHighThreshold = () => this.transform(this.channel.fcuData.alarmSettingHigh.setPoint);
    isVeryHighAlarmEnabled = () => this.channel.fcuData.alarmSettingVeryHigh.enable;
    getVeryHighThreshold = () => this.transform(this.channel.fcuData.alarmSettingVeryHigh.setPoint);

    getVeryHighAlarmLevel = () => this.channel.fcuData.alarmSettingVeryHigh.alarmLevel;
    getHighAlarmLevel = () => this.channel.fcuData.alarmSettingHigh.alarmLevel;
    getLowAlarmLevel = () => this.channel.fcuData.alarmSettingLow.alarmLevel;
    getVeryLowAlarmLevel = () => this.channel.fcuData.alarmSettingVeryLow.alarmLevel;
}
